import module from "./WhatsItem.module.css";
import styles from "../layout/utils.module.css";

function WhatsItem({ imgPath, textPath, title, description }) {
    const bothSizePath = (name) =>
      `${process.env.PUBLIC_URL + "/lp/both/" + name}`;

    return (
        <div className={module.item}>
            <div className={module.left}>
                <img className={module.img} src={bothSizePath(imgPath)} />
                <span className={module.bg}></span>
                <img className={module.name} src={bothSizePath(textPath)}/>
            </div>

            <div className={module.right}>
                <p className={`${module.title} ${styles.fontBold} ${styles.textLeft} ${styles.yugo} ${styles.f24}`}>
                    {title}
                </p>

                <p className={`${module.txt} ${styles.f16} ${styles.yugo} ${styles.textLeft}`}>
                    {description}
                </p>
            </div>
        </div>
    );
}

export default WhatsItem;